import { CAP, DIODE, LOAD, REMOVED } from "../../../constants/componentType";
import { FERRITE, IGNORE, IND, JUMPER, RES, SWITCH } from "../../PCBHelper";
import _ from 'lodash';
import auroraDBJson from "../../Designs/auroraDbData";
import { getNearbyComponent } from "../../Designs/helper";
import GetPMICs from "../../helper/componentsHelper/GetPath/getPMIC";
import { defaultGroundNets } from '../../../constants/defaultGroundNets';

function getComponents(netList, pcbId, specify = []) {
  const specifyName = specify.map(item => item.name);
  const Components = auroraDBJson.getComponentsByNets(pcbId, netList);
  const findCaps = Components.filter(item => item.type === CAP);
  const findVRMComps = Components.filter(item => [IND, RES, JUMPER, FERRITE, SWITCH, DIODE].includes(item.type) || item.pmicType || specifyName.includes(item.name))
    .map(item => ({ ...item, nets: [...new Set([...item.pins.values()])] }))
  return { Components, findVRMComps, findCaps };
}

function getPowerPinList(type, COMP_PREFIX_LIB = {}, record, Components = []) {
  if (!record || !COMP_PREFIX_LIB) {
    return [];
  }
  const { PowerNets = [], ReferenceNets = [], VRM } = record;
  let nets = [], rules = null;
  const { Res = [], Ind = [], Cap = [], Jumper = [], Ferrite = [], powerSwitch = [] } = COMP_PREFIX_LIB;
  //When COMP_PREFIX_LIB is modified, re-acquire the names
  let res = [...Res], ind = [...Ind], cap = [...Cap],
    jumper = [...Jumper], ferrite = [...Ferrite];
  let resRules = "", indRules = "", capRules = "", jumperRules = "", ferriteRules = "";
  let partName = [...powerSwitch];

  let getRule = (arr) => {
    let rules = ""
    arr.forEach((item, index) => {
      if (index === 0) {
        rules = "^" + item;
      } else {
        rules = resRules + "|^" + item;
      }
    })
    return rules
  }

  resRules = getRule(res);
  indRules = getRule(ind);
  capRules = getRule(cap);
  jumperRules = getRule(jumper);
  ferriteRules = getRule(ferrite);
  const vrmComp = VRM.map(item => item.VRM_COMP).flat(2);

  //resRules eg: ^R|RT
  //indRules eg: ^L
  //indRules eg: ^C|CT
  if (type === 'powerPin') {
    nets = PowerNets || [];
    //rules = /^R|^L/i;
    let powerRules = ""
    if (!res.length && !ind.length && !jumper.length && !ferrite.length) {
      return [];
    }
    if (resRules) {
      powerRules = powerRules ? `${powerRules}|${resRules}` : resRules;
    }
    if (indRules) {
      powerRules = powerRules ? `${powerRules}|${indRules}` : indRules;
    }
    if (jumperRules) {
      powerRules = powerRules ? `${powerRules}|${jumperRules}` : jumperRules;
    }
    if (ferriteRules) {
      powerRules = powerRules ? `${powerRules}|${ferriteRules}` : ferriteRules;
    }
    rules = new RegExp(powerRules, 'i');
  } else {
    nets = ReferenceNets || [];
    //rules = /^C/i;
    if (capRules) {
      rules = new RegExp(`${capRules}`, 'i');
    } else {
      return [];
    }

  };
  // Filter components connect to power or ground
  return Components.filter(comp => {
    if (!comp) return false;
    if (partName.includes(comp.part)) {
      return comp;
    }
    const _nets = comp.pins.map(item => item.net);
    for (const net of _nets) {
      // Only Cap will have Removed usage
      if (comp.usage !== REMOVED && nets.includes(net) && rules.test(comp.name)) {
        return comp;
      } else if (type === 'powerPin' && nets.includes(net) && (comp.usage === 'Switch' || vrmComp.includes(comp.name))) {
        return comp;
      }
    };
    return false;
  });
}

function getAllRockyComponents({ pcbId, isList }) {
  const Components = auroraDBJson.getComponents(pcbId);
  if (isList) {
    return [...Components.values()];
  }
  return Components;
}

function getirPDNComponentsByNets({ ReferenceNets, PowerNets, pcbId, specify = [] }) {
  const { Components, findVRMComps, findCaps } = getComponents([...ReferenceNets, ...PowerNets], pcbId, specify);
  let new_Components = ComponentsFilter({ Components, ReferenceNets, PowerNets });
  new_Components = addMultiNetsFieldToCapComps({ Components: new_Components, pcbId });
  const _findCaps = findCaps.map(item => { return { ...item, pins: [...item.pins.values()] } })
  return { Components: new_Components, findVRMComps, findCaps: _findCaps }
}

function ComponentsFilter({ Components, PowerNets, ReferenceNets, includesCap = false }) {
  const _Components = _.cloneDeep(Components);
  const _filter = _Components.filter(comp => {
    if (comp.type === CAP && !includesCap) { return false }
    let nets = [...new Set([...comp.pins.values()].map(item => item.net))];
    if (nets.every(net => PowerNets.includes(net))) {
      // Component only connect to referenceNets
      if (nets.length > 1) {
        return comp;
      } else {
        if (includesCap) {
          if (comp.type !== CAP) {
            // If the component is only connected to single power net and the usage is not 'Cap', the usage is set to Ignore.
            comp.type = IGNORE;
            return comp;
          } else {
            return false;
            // Remove the 'Cap' components;
          }
        }
        return false;
        // The component only connect to single ground net.
      }
    } else if (nets.every(net => [...PowerNets, ...ReferenceNets].includes(net))) {
      // Component only connect to PowerNets
      if (nets.length > 1) {
        if (comp.type === SWITCH && includesCap) {
          nets = nets.filter(net => !ReferenceNets.includes(net))
          if (nets.length === 1) {
            comp.type = IGNORE;
          }
        }
        return comp;
      } else {
        return false;
      }
    } else {
      const new_net = nets.filter(item => PowerNets.includes(item))
      if ([...new Set(new_net)].length > 1) {
        return comp;
      }
      return false
    }
  });
  return _filter;
};

//Add isMultiNets to cap components to supports caps that connect to more than 2 nets
function addMultiNetsFieldToCapComps({ Components, pcbId, isVersionUpdate = false }) {
  const allComponents = getAllRockyComponents({ pcbId })

  //If the nets to which the cap component is connected is greater than 2, true
  for (let comp of Components) {
    if (comp.type !== CAP || (!isVersionUpdate && comp.isMultiNets !== undefined)) {
      continue;
    }
    const findComp = allComponents.get(comp.name);
    if (!findComp) {
      continue;
    }
    const pinNets = [...new Set([...findComp.pins.values()].map(item => item.net))];
    comp.isMultiNets = pinNets.length > 2 ? true : false;
  }
  return Components;
}

function getReferenceComps({ VRM_COMPS = [], findCaps, ReferenceNets, pcbId, powerPinList = [] }) {
  let VRMComponents = [];
  let referenceComps = [...findCaps];
  if (VRM_COMPS.length) {
    const _Components = auroraDBJson.getComponentsByNames(pcbId, VRM_COMPS)
    VRMComponents = _Components.map(item => ({ name: item.name, pins: [...item.pins.values()] }))
    referenceComps.push(...VRMComponents)
  }
  if (powerPinList.length) {
    const _powers = powerPinList.filter(item => item.type !== CAP && item.usage !== LOAD && item.pins.some(pin => ReferenceNets.includes(pin.net)))
    referenceComps.push(..._powers)
  }
  referenceComps = referenceComps.filter(item => item.name);
  return { referenceComps, VRMComponents }
}

function _getVRM({
  designId,
  GroundNets,
  PowerNets,
  ExtendNets,
  ExistNets,
  COMP_PREFIX_LIB,
  loadSelect,
  connectInductance,
  findExtend = true,
  isAC = false,
  powerSwitch = [],
  doNotStuff = [],
  buckConverter,
  table = [],
  pinMapSense,
  isTemplate,
  pinConnection = [],
  pmicAndNets = [],
  pinMap = [],
  PMIC = []
}) {
  let getPMICs = {};
  let comps = loadSelect.map(select => select.comp);
  let _powerNets = PowerNets.filter(item => {
    const netInfo = auroraDBJson.getNet(designId, item)
    return netInfo && netInfo.pins && comps.some(comp => netInfo.pins.has(comp)) ? true : false;
  })
  const getPMIC = new GetPMICs({
    ReferenceNets: [...GroundNets],
    PowerNets: [..._powerNets, ...ExtendNets],
    designId,
    COMP_PREFIX_LIB,
    findExtend,
    ExistNets,
    connectInductance,
    chips: comps,
    isAC,
    PMIC: PMIC,
    powerSwitch,
    doNotStuff,
    buckConverter,
    pinMapSense,
    isTemplate,
    pinConnection,
    componentTable: table,
    pmicAndNets,
    pinMap,
    specify: [],
    fullPaths: true
  })
  getPMICs = getPMIC.getPMICs();
  return getPMICs;
}

function sortReference(refeList, designId, pwr, pwrPins = [], referenceNets = []) {
  if (!designId || !pwr || !pwrPins.length) {
    return refeList.map(item => item.name);
  }
  const compPins = auroraDBJson.getComponentPins(designId, pwr).filter(pin => pwrPins.includes(pin.pinName))
  const pwrNets = compPins.map(item => item.net);
  const refes = getNearbyComponent({
    designId,
    target: pwr,
    components: refeList.map(item => item.name),
    targetNets: [...new Set(pwrNets)],
    sameLayer: false,
    nets: referenceNets,
    returnList: true
  })
  return refes
}

function getDisplayDetail(details, sense = false) {
  let newDetailList = [];
  let maxLength = 0;
  for (let detail of details) {
    if (detail.length > maxLength) {
      maxLength = detail.length;
    }
    let _detail = Array.isArray(detail) ? detail.map((item, index) => {
      if (item.type === 'net') {
        return item.name
      } else {
        return index === detail.length - 1 ?
          item.pins && item.pins.length ? `{${item.name}::${item.pins.map(p => p.pinName).join('::')}}` : `{${item.title ? item.title : item.name}}`
          : `[${item.name}]`;
      }
    }) : [];
    newDetailList.push(_detail);
  }
  return newDetailList
}

let truePowerNets = [], filterPowerNets = JSON.parse(JSON.stringify(defaultGroundNets)), maxLevel = 4;

function getRockyMainPowerNet(powerNets, targetIC, designId, COMP_PREFIX_LIB) {
  const components = getAllRockyComponents({ pcbId: designId });

  const ic = components.get(targetIC);
  if (!ic) {
    return powerNets;
  }
  const icPowerNets = [...ic.pins.values()].map(item => item.net);
  for (let powerNet of powerNets) {
    const _powerNets = icPowerNets.filter(net => net === powerNet);
    if (_powerNets.length < 3) {
      filterPowerNets.push(powerNet);
      traceTruePowerNet(powerNet, icPowerNets, designId, COMP_PREFIX_LIB, 1);
    } else {
      truePowerNets.push(powerNet);
    }
  }

  if (!truePowerNets.length) {
    truePowerNets = [];
    filterPowerNets = JSON.parse(JSON.stringify(defaultGroundNets));
    return powerNets;
  }

  let truePowerNet = truePowerNets[0], max = 0;
  for (let trueNet of truePowerNets) {
    const _powerNets = icPowerNets.filter(net => net === trueNet);
    if (_powerNets.length > max) {
      max = _powerNets.length;
      truePowerNet = trueNet;
    }
  }

  truePowerNets = [];
  filterPowerNets = JSON.parse(JSON.stringify(defaultGroundNets));
  return [truePowerNet]
}

function traceTruePowerNet(powerNet, icPowerNets, designId, COMP_PREFIX_LIB, level) {
  // 已测试
  if (level >= maxLevel) {
    return;
  }
  const _components = getAllRockyComponents({ pcbId: designId });
  const components = auroraDBJson.getComponentsByNets(designId, [powerNet]).filter(item => [RES, JUMPER, FERRITE, SWITCH, IND].includes(item.type))
    .map(comp => _components.get(comp.name)).filter(item => !!item);
  let newNets = [], hasNet = false;
  for (let comp of components) {
    const _filterPowerNets = filterPowerNets;
    const nets = [...comp.pins.values()].map(pin => pin.net).filter(n => !_filterPowerNets.includes(n));
    for (let net of nets) {
      const _powerNets = icPowerNets.filter(n => n === net);
      if (_powerNets.length < 3) {
        filterPowerNets.push(net);
        newNets.push(net)
      } else {
        truePowerNets.push(net);
        hasNet = true
      }
    }
  }

  if (hasNet) {
    return;
  }

  newNets.forEach(net => traceTruePowerNet(net, icPowerNets, designId, COMP_PREFIX_LIB, level + 1))
}

function componentsFilter({ Components, PowerNets, ReferenceNets }) {
  const _Components = JSON.parse(JSON.stringify(Components));
  const _filter = _Components.filter(comp => {
    if (comp.usage === 'Cap') { return false }
    const nets = [...new Set(comp.pins.map(item => item.net))];
    if (nets.every(net => PowerNets.includes(net))) {
      // Component only connect to referenceNets
      if (nets.length > 1) {
        return comp;
      } else {
        return false;
        // The component only connect to single ground net.
      }
    } else if (nets.every(net => [...PowerNets, ...ReferenceNets].includes(net))) {
      // Component only connect to PowerNets
      if (nets.length > 1) {
        return comp;
      } else {
        return false;
      }
    } else {
      const new_net = nets.filter(item => PowerNets.includes(item))
      if (new_net.length > 1) {
        return comp;
      }
      return false
    }
  });
  return _filter;
};

function getConnectNets({ PowerNets, Components, isAC }) {
  let _Components = componentsFilter({ Components, PowerNets: PowerNets, ReferenceNets: [] })
  let connectNets = {}, netsInfo = {};
  const typeList = isAC ? ['Res', 'Ind', 'Jumper', 'Switch', 'Ferrite'] : ['Res', 'Ind', 'Jumper', 'Switch', 'Ferrite', 'Diode'];
  _Components = _Components.filter(item => typeList.includes(item.usage));
  _Components.forEach(comp => {
    const nets = comp.pins.map(item => item.net);
    PowerNets.forEach(net => {
      if (nets.includes(net)) {
        if (netsInfo[net]) {
          netsInfo[net].push({ name: comp.name, type: comp.COMP_TYPE })
        } else {
          netsInfo[net] = [{ name: comp.name, type: comp.COMP_TYPE }]
        }
      }
    })
  })
  const filterNets = Object.keys(netsInfo);
  filterNets.forEach(net => {
    if (netsInfo[net].length) {
      const types = netsInfo[net].map(item => item.type)
      if (types.every(net => ['Ind'].indexOf(net) > -1)) {
        netsInfo[net].forEach(it => {
          if (connectNets[it.name]) {
            connectNets[it.name].push(net)
          } else {
            connectNets[it.name] = [net]
          }
        })
      }
    }
  })

  return connectNets
}

export {
  getPowerPinList as newGetPowerPinList,
  getirPDNComponentsByNets as newGetirPDNComponentsByNets,
  getReferenceComps as newGetReferenceComps,
  _getVRM as _newGetVRM,
  sortReference as newSortReference,
  getAllRockyComponents as newGetAllRockyComponents,
  getDisplayDetail as newGetDisplayDetail,
  getRockyMainPowerNet as newGetRockyMainPowerNet,
  getPowerPinList,
  getirPDNComponentsByNets,
  getReferenceComps,
  _getVRM,
  sortReference,
  getAllRockyComponents,
  getDisplayDetail,
  getRockyMainPowerNet
};